import type { CareRequest } from '../hooks/useCareRequests';

interface Props {
  status: CareRequest['status'];
}

const CONFIG: Record<CareRequest['status'], { bg: string; text: string; dot: string }> = {
  접수: { bg: 'bg-amber-50', text: 'text-amber-600', dot: 'bg-amber-400' },
  진행중: { bg: 'bg-blue-50', text: 'text-blue-600', dot: 'bg-blue-400' },
  완료: { bg: 'bg-emerald-50', text: 'text-emerald-600', dot: 'bg-emerald-500' },
};

export default function StatusBadge({ status }: Props) {
  const c = CONFIG[status];
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${c.bg} ${c.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`}></span>
      {status}
    </span>
  );
}
